export interface CreateCollectionListDetailListRequest {
  bibliographyRealIds: number[]
}

export function CreateCollectionListDetailListRequestToJSON(
  value: CreateCollectionListDetailListRequest
): any {
  return {
    bibliography_real_ids:
      value.bibliographyRealIds.length > 0
        ? value.bibliographyRealIds
        : undefined
  }
}
